import React from 'react';
import { BRAND_ALT, BRAND_ASSETS, BRAND_NAME } from '../constants/brand';

/**
 * 标志本身：裸资产、无外加阴影/光晕（避免「贴纸补丁」感）。
 * 图标 PNG 已自带圆角底板，不再二次造阴影舞台。
 */
const MARK_SIZE = {
  xs: 'h-7 w-7',
  sm: 'h-8 w-8',
  md: 'h-11 w-11',
  lg: 'h-14 w-14',
  xl: 'h-[4.25rem] w-[4.25rem]',
  hero: 'h-16 w-16 sm:h-[4.75rem] sm:w-[4.75rem]',
};

export function BrandMark({
  size = 'md',
  className = '',
  src,
  alt = BRAND_ALT,
  decorative = false,
}) {
  const dim = MARK_SIZE[size] || MARK_SIZE.md;
  const asset =
    src ||
    (size === 'hero' || size === 'xl' ? BRAND_ASSETS.logo512 : BRAND_ASSETS.logo192);

  return (
    <img
      src={asset}
      alt={decorative ? '' : alt}
      aria-hidden={decorative ? true : undefined}
      draggable={false}
      className={`brand-glyph ${dim} ${className}`.trim()}
    />
  );
}

/**
 * 品牌一体锁：标志 + 字标作为单一构图，不再上下「贴图标再贴字」。
 * - inline：产品顶栏 / 落地英雄同行
 * - stack：登录等居中场景，仍保持紧凑一体节奏
 */
export default function BrandLockup({
  layout = 'inline',
  size = 'md',
  tone = 'ink',
  title = BRAND_NAME,
  subtitle,
  className = '',
  titleClassName = '',
  subtitleClassName = '',
}) {
  const isStack = layout === 'stack';
  const titleTone =
    tone === 'cream'
      ? 'text-[#f7efe8]'
      : tone === 'primary'
        ? 'text-primary-600 dark:text-primary-400'
        : 'text-neutral-800 dark:text-dark-text';

  const titleScale = {
    xs: 'text-lg',
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-3xl',
    xl: 'text-4xl',
    hero: 'text-[2.75rem] sm:text-5xl',
  }[size] || 'text-2xl';

  return (
    <div
      className={`brand-lockup brand-lockup--${layout} ${className}`.trim()}
      role="group"
      aria-label={title}
    >
      <BrandMark size={size} decorative={Boolean(title)} />
      <div className={`brand-lockup__text ${isStack ? 'items-center text-center' : 'items-start text-left'}`}>
        <span className={`brand-lockup__title ${titleScale} ${titleTone} ${titleClassName}`.trim()}>
          {title}
        </span>
        {subtitle ? (
          <span className={`brand-lockup__subtitle ${subtitleClassName}`.trim()}>{subtitle}</span>
        ) : null}
      </div>
    </div>
  );
}
